import { createFileRoute } from '@tanstack/react-router'

import { NoCards } from '~/boundedContext/cards/pages/no-cards'

export const Route = createFileRoute('/_main-layout/cards/no-cards')({
  component: NoCards,
})
